import { Element, useNode } from "@craftjs/core";
import { TextWithValue } from "../TextWithValue";
import { isMobile } from "react-device-detect";
import { cn } from "@/src/shared/utils/mergeTwClasses";

export function List(props: any) {
  const { disableMobileDecoration } = props;

  const withoutDecoration = !!disableMobileDecoration && isMobile;
  return (
    <div className={"w-full"}>
      {props.listType === "number" && (
        <ol className={"flex list-decimal flex-col pl-8"} style={props.style}>
          {props.items.map((item: any, index: number) => (
            <li key={index}>
              <Element
                is={TextWithValue}
                id={`test-${index}`}
                canvas
                text={item.value}
              />
            </li>
          ))}
        </ol>
      )}
      {props.listType === "bullet" && (
        <ul className="flex list-disc flex-col pl-8" style={props.style}>
          {props.items.map((item: any, index: number) => (
            <li key={index}>
              <Element
                is={TextWithValue}
                id={`test-${index}`}
                canvas
                text={item.value}
              />
            </li>
          ))}
        </ul>
      )}
      {props.listType === "custom" && (
        <ul className={"flex list-inside flex-col"} style={props.style}>
          {props.items.map((item: any, index: number) => (
            <li
              key={index}
              className={cn(
                "flex items-center",
                !withoutDecoration &&
                  "ml-2 bg-[length:16px_16px] bg-left bg-no-repeat pl-6",
              )}
              style={{
                backgroundImage: withoutDecoration
                  ? "none"
                  : `url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIyNl8yMTIxKSI+CjxwYXRoIGQ9Ik0xNy44Mjk2IDAuNzYwMjdDMTguMDMwNiAwLjkyNzggMTguMDU3NiAxLjIyNjUgMTcuODkwMSAxLjQyNzQzTDYuNDI3OTUgMTUuMTc1QzYuMzQxNTIgMTUuMjc4NyA2LjIxNDk3IDE1LjM0MDYgNi4wODAwOCAxNS4zNDUxQzUuOTQ1MTkgMTUuMzQ5NyA1LjgxNDc3IDE1LjI5NjQgNS43MjE1NiAxNS4xOTg4TDAuMTMxMTExIDkuMzQ0NjdDLTAuMDQ5NTYxMiA5LjE1NTQ3IC0wLjA0MjY1MjEgOC44NTU2NyAwLjE0NjU0MSA4LjY3NDk3QzAuMzM1NzQxIDguNDk0MjcgMC42MzU1ODEgOC41MDExNyAwLjgxNjI2MSA4LjY5MDM3TDYuMDQwMTcgMTQuMTYwN0wxNy4xNjI1IDAuODIwNzQ5QzE3LjMzIDAuNjE5ODE5IDE3LjYyODcgMC41OTI3NCAxNy44Mjk2IDAuNzYwMjdaIiBmaWxsPSIjMDA5RERFIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjI2XzIxMjEiPgo8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==)`,
              }}
            >
              <Element
                is={TextWithValue}
                id={`test-${index}`}
                canvas
                text={item.value}
              />
            </li>
          ))}
        </ul>
      )}
      {props.items.length === 0 && <div>Список пустий</div>}
    </div>
  );
}
